import React from 'react';
import Slider from 'react-slick';
import creditCard from '../images/credit-card.png';

// used in mobile
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './BuildingPayment.css';
import BuildingTitle from '../../components/common/buildingTitle';
// used to safely extract html strings
import ReactHtmlParser from 'react-html-parser';
import { withTranslation } from 'react-i18next';
import Parent from '../common/parent';
import { constants } from "../common/constants/constants";

const sliderSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 400,
            settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }
    ]
};

export class BuildingPayments extends Parent {

    constructor(props) {
        super(props);
        document.title = props.t('titles.building_profile');

        this.state = {
            building: {
                managers: [],
                titleData: {translationKey: 'welcome'}
            },
            text: {}
        }
    }

    async componentDidMount() {
        const { t } = this.props;
        this.startLoader();
        await this.fetchBuildingData(this.props.match.params.buildingID);
        // todo change favicon based on partner's logo (if exists)
        function removeFavicon()
        {
            var links=document.getElementsByTagName('link');
            var head=document.getElementsByTagName('head')[0];
            for(var i=0; i<links.length; i++)
            {
                if(links[i].getAttribute('rel')==='icon')
                {
                    head.removeChild(links[i])
                }
            }
        }

// Chrome allows you to simply tweak the HREF of the LINK tag.
// Firefox appears to require that you remove it and re-add it.
        function setFavicon(url)
        {
            removeFavicon();
            var link=document.createElement('link');
            link.type='image/x-icon';
            link.rel='icon';
            link.href=url;
            document.getElementsByTagName('head')[0].appendChild(link);
            if (window.console) console.log("Set FavIcon URL to " + getFavicon().href);
        }

        function getFavicon()
        {
            var links=document.getElementsByTagName('link');
            for(var i=0; i<links.length; i++)
            {
                if (links[i].getAttribute('rel')==='icon')
                {
                    return links[i];
                }
            }
            return undefined;
        }

        const favicons = ['https://www.ptop.co.il/images/3rdParty/danielFixLogo.jpg', 'https://www.ptop.co.il/images/3rdParty/ogen_Logo.jpg', 'https://www.ptop.co.il/images/3rdParty/aabm.png', 'https://s3.amazonaws.com/PtoPTempHosts/av-bait.png'];
        const favicon = favicons[Math.random() * favicons.length | 0];
        if (favicon) {
            setFavicon(favicon);
        }

        const isViewedByManager = await this.isLoggedIn();
        this.setState({
            isViewedByManager: isViewedByManager
        })
        // https://stackoverflow.com/a/33926752/13806459 You can use JavaScript. Some bots, including Google, will execute the JavaScript for the benefit of SEO (showing the correct title in the SERP).
        const titleData = this.buildingTitle(this.state.building.address, null, 'paymentTo');
        document.title = t('titles.building_profile') + ' ' + t('payments.' + titleData.translationKey, titleData);
        this.genericBinds(this.props.history);
        this.endLoader();
    }

    render() {
        const { t } = this.props;
        const buildingID = this.props.match.params.buildingID;
        this.setBodyClasses(constants.backgroundOptions.buildingProfileForTenant);
        const tenantDetailsUrl = this.state.isViewedByManager ?
        `/${constants.pages.tenantDetailsManagerUrl}/${buildingID}` :
        `/${constants.pages.tenantDetailsUrl}/${buildingID}`;

        return(
            <section>
                <div className="container">
                    <div className="row banner-sec-set">
                        <div className="banner-sec payment-heading">
                            <BuildingTitle
                                address={this.state.building.address} type={'welcome'}
                            />
                            <p>{t('payments.buildingPageExplain-1')} <span role="img" aria-label="smiley">&#129303;</span> {t('payments.buildingPageExplain-2')} </p>
                            <a data-testid='pay-link' className="banner-btn js-href" href={tenantDetailsUrl}>
                                <img className="js-href" alt="credit card" src={creditCard}/>{t('payments.makePayment')}
                            </a>

                        </div>
                        <div className="col-sm-12">
                            <div className="txt-box">
                                <div className="col-sm-6 colume-1">
                                    <div className="mid-sec-right">
                                        <h4 className='label'>{t('payments.managers')}</h4>
                                        <section className="regular slider">
                                            <Slider {...sliderSettings}>
                                                {this.state.building.managers.map((value, index) => {
                                                    return <div key={index} className="set-slider">
                                                                <img alt={value.full_name} src={value.avatar_url} />
                                                                <p>{value.full_name}</p>
                                                            </div>
                                                })}
                                            </Slider>
                                        </section>
                                    </div>
                                </div>
                                <div className="col-sm-6 colume-2">
                                    <div className="mid-sec-left">
                                        <h4 className='label'>{t('payments.updates')}</h4>
                                        <p>{ReactHtmlParser(this.state.building.updates)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        )
    }

}


export default withTranslation()(BuildingPayments);
